import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextareaAutosize } from '@mui/material'
import Editor from 'components/editor'

const CreateModal = ({ handleRefresh }) => {
  const uploadImage = useUploadImage()

  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [description, setDescription] = useState('')
  const [images, setImages] = useState([])

  const [videoUrls, setVideoUrls] = useState([])
  const handleAddVideo = () => {
    if (videoInput.trim()) {
      setVideoUrls([...videoUrls, videoInput.trim()])
      setVideoInput('')
    }
  }
  const [videoInput, setVideoInput] = useState('')
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files)
    setImages(files)
  }

  const handleRemoveImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  // console.log(svgIcon, "svgIcon")
  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }
  const handleRemoveVideo = (index) => {
    setVideoUrls(videoUrls.filter((_, i) => i !== index))
  }


  const handleSubmit = async (e) => {

    e.preventDefault();
    setProcessing(true);
    let uploadedImages = []

    if (images.length > 0) {
      try {
        const uploadPromises = images.map((file) =>
          uploadImage({ file, desiredPath: `app/logo/image` })
        )
        const responses = await Promise.all(uploadPromises)
        uploadedImages = responses.map((res) => res?.response?.data).filter(Boolean)
      } catch (error) {
        console.error('Image upload failed:', error)
      }
    }

    const handleAddVideo = () => {
      if (videoInput.trim()) {
        setVideoUrls([...videoUrls, videoInput.trim()])
        setVideoInput('')
      }
    }

    const handleRemoveVideo = (index) => {
      setVideoUrls(videoUrls.filter((_, i) => i !== index))
    }
    const payload = {
      name: e.target.name.value,
      description,
      date: e.target.date.value,
      image: uploadedImages,
      videos: videoUrls,
    };

    console.log(payload, "payload");

    const { response } = await AppService.property_type.create({ payload })

    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
      setImages([])
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} >
            <MDTypography variant="h5" mb={2}>
              Create Property Type
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>
            <Stack direction="row" alignItems="center" spacing={2}>
                         <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                           Upload Images +
                           <input hidden name="image" type="file" multiple onChange={handleFileChange} />
                         </Button>
                       </Stack>
                       
                       {images.length > 0 && (
                         <MDBox mt={2}>
                           <MDTypography variant="button">Selected Images:</MDTypography>
                           <Stack direction="row" spacing={1} mt={1}>
                             {images.map((file, index) => (
                               <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                                 <img
                                   src={file instanceof File ? URL.createObjectURL(file) : file}
                                   alt={`preview-${index}`}
                                   width={50}
                                   height={50}
                                   style={{ borderRadius: 5 }}
                                 />
                                 <button
                                   type="button"
                                   onClick={() => handleRemoveImage(index)}
                                   style={{
                                     position: 'absolute',
                                     top: -5,
                                     right: -5,
                                     background: 'rgba(255, 132, 132, 0.7)', // Make the background slightly transparent
                                     color: 'red',
                                     border: 'none',
                                     borderRadius: '50%',
                                     cursor: 'pointer',
                                     width: 20,
                                     height: 20,
                                     fontSize: '16px',
                                     lineHeight: '16px', // Center the 'x' in the button
                                     display: 'flex',
                                     justifyContent: 'center',
                                     alignItems: 'center',
                                   }}
                                 >
                                   &times;
                                 </button>
                               </div>
                             ))}
                           </Stack>
                         </MDBox>
                       )}

                       
            <MDBox mt={2}>
  <Stack direction="row" spacing={1} alignItems="center">
    
    <Button variant="contained" onClick={handleAddVideo} style={{ color: "white" }}>
      Add
    </Button>
  </Stack>

  {videoUrls.length > 0 && (
    <Stack mt={2} spacing={1}>
      {videoUrls.map((url, index) => (
        <div key={index} style={{ position: 'relative' }}>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ display: 'flex' }}>
            <MDTypography
              variant="h6"
              sx={{
                fontWeight: 'medium',
                fontSize:12,
                color:"black",
                cursor: 'pointer',
                width: '100%',
                background: 'rgba(0, 0, 0, 0.05)', // Subtle background color
                padding: '8px 12px', // Padding to give some space around the link
                borderRadius: '5px', // Slight border radius for a soft look
                transition: 'background-color 0.3s ease, color 0.3s ease', // Smooth transitions on hover
                '&:hover': {
                  backgroundColor: 'rgba(0, 123, 255, 0.1)',
                  color: '#007bff', 
                },
              }}
            >
              {url}
            </MDTypography>
          </Stack>

          {/* Remove button */}
          <button
            type="button"
            onClick={() => handleRemoveVideo(index)}
            style={{
              position: 'absolute',
              top: -5,
              right: -5,
              background: 'rgba(255, 132, 132, 0.7)',
              color: 'red',
              border: 'none',
              borderRadius: '50%',
              cursor: 'pointer',
              width: 20,
              height: 20,
              fontSize: '16px',
              lineHeight: '16px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            &times;
          </button>
        </div>
      ))}
    </Stack>
  )}
           </MDBox>





            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
